import { capitalize, Spacer, Tag } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import styled from "styled-components";
import {
  ArrowDownwardOutlined,
  ArrowUpwardOutlined,
} from "@qivia/ui/src/designSystem/materialUi/materialUi";
import { MileageDeviationStatus } from "../fleetApi";

export const DeviationCell = ({
  statusSeverity,
  value,
}: {
  statusSeverity: string | undefined;
  value: string;
}) => (
  <StyledDeviationCell>
    {statusSeverity === "warning" && (
      <StyledDeviationIcon
        $color={colors["colors/system/warning/warning_dark"]}
      >
        <ArrowDownwardOutlined />
      </StyledDeviationIcon>
    )}
    {statusSeverity === "error" && (
      <StyledDeviationIcon $color={colors["colors/system/error/error_dark"]}>
        <ArrowUpwardOutlined />
      </StyledDeviationIcon>
    )}
    {statusSeverity && statusSeverity !== "success" && <Spacer x={0.25} />}
    {capitalize(value)}
  </StyledDeviationCell>
);

const tagConfig: Record<
  MileageDeviationStatus,
  {
    iconLeft?: JSX.Element;
    iconColor?: string;
    backgroundColor: string;
    textColor: string;
  }
> = {
  UNDERROLLING: {
    iconLeft: <ArrowDownwardOutlined />,
    iconColor: colors["colors/system/warning/warning_dark"],
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_dark"],
  },
  OVERROLLING: {
    iconLeft: <ArrowUpwardOutlined />,
    iconColor: colors["colors/system/error/error_dark"],
    backgroundColor: colors["colors/system/error/error_ultraLight"],
    textColor: colors["colors/system/error/error_dark"],
  },
  CORRECT: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_dark"],
  },
};

export const MileageDeviationTag = ({
  status,
  text,
}: {
  status: MileageDeviationStatus;
  text: string;
}) => {
  const { iconLeft, iconColor, backgroundColor, textColor } = tagConfig[status];
  return (
    <Tag
      text={text}
      {...(iconLeft ? { iconLeft, iconColor } : {})}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};

const StyledDeviationCell = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDeviationIcon = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
    fill: ${({ $color }) => $color};
  }
`;
